import { StoreState } from '@/redux/types';

export const selectProductTypes = (state: StoreState) => state.productTypes.detail;
